import { render, staticRenderFns } from "./DistrictInfo.vue?vue&type=template&id=574c7a98&scoped=true&"
import script from "./DistrictInfo.vue?vue&type=script&lang=js&"
export * from "./DistrictInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574c7a98",
  null
  
)

export default component.exports